import { UnitOfMeasure } from './enums';

export const unitOptions = [
  { value: UnitOfMeasure.Piece, label: 'Piece' },
  { value: UnitOfMeasure.Set, label: 'Set' },
  { value: UnitOfMeasure.Meter, label: 'Meter' },
  { value: UnitOfMeasure.Foot, label: 'Foot' },
  { value: UnitOfMeasure.Inches, label: 'Inches' },
  { value: UnitOfMeasure.Liter, label: 'Liter' },
  { value: UnitOfMeasure.Roll, label: 'Roll' }
];

export const unitOfMeasureMapping: Record<string, UnitOfMeasure> = {
  Piece: UnitOfMeasure.Piece,
  Set: UnitOfMeasure.Set,
  Meter: UnitOfMeasure.Meter,
  Foot: UnitOfMeasure.Foot,
  Inches: UnitOfMeasure.Inches,
  Liter: UnitOfMeasure.Liter,
  Roll: UnitOfMeasure.Roll
};

export const getUnitLabel = (unitOfMeasure?: number | string | null) => {
  const value = Number(unitOfMeasure);
  return unitOptions.find(o => o.value === value)?.label ?? String(unitOfMeasure ?? '');
};

/**
 * Units allowed when receiving inventory.
 * Any non-Roll unit can become the product stock UOM on approve; Roll needs pack size.
 */
export const getReceivableUnitOptions = (packSize?: number | null) => {
  const options = unitOptions.filter(o => o.value !== UnitOfMeasure.Roll);
  if (packSize != null && packSize > 0) {
    const roll = unitOptions.find(o => o.value === UnitOfMeasure.Roll);
    if (roll) options.push(roll);
  }
  return options;
};

/** @deprecated Prefer getReceivableUnitOptions — kept for callers that still pass stock UOM. */
export const getConvertibleUnitOptions = (
  _stockUnitOfMeasure?: number | null,
  packSize?: number | null
) => getReceivableUnitOptions(packSize);
